import React from "react";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import { LinkedIn } from "@mui/icons-material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import FmdGoodIcon from "@mui/icons-material/FmdGood";

const logo = "https://dwww47q4ijt56.cloudfront.net/amoservtech/logo.png";

const Xapp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 17 16" fill="none">
  <path d="M13.2835 0.6875H15.7645L10.3442 6.8825L16.7207 15.3125H11.728L7.81745 10.1998L3.34295 15.3125H0.860478L6.65795 8.68625L0.540977 0.6875H5.66045L9.1952 5.36075L13.2835 0.6875ZM12.4127 13.8275H13.7875L4.91345 2.0945H3.4382L12.4127 13.8275Z" fill="#fff"/>
</svg>
);

const Footer = () => {
  return (
    <footer className="footer">
      <img src={logo} alt="Amorserv Tech Logo"   className="footer-logo" />
      <div className="socials">
        <a href="https://web.facebook.com/amorservtech" target="_blank" rel="noopener noreferrer">
          <FacebookOutlinedIcon className="social-icon" />
        </a>
        <a href="https://twitter.com/amorservtech" target="_blank" rel="noopener noreferrer">
          <Xapp className="social-icon" />
        </a>
        <a href="https://www.instagram.com/amorservtech/" target="_blank" rel="noopener noreferrer">
          <InstagramIcon className="social-icon" />
        </a>
        <a
          href="https://www.linkedin.com/company/amorserv-tech"
          target="_blank"
          rel="noopener noreferrer"
        >
          <LinkedIn className="social-icon" />
        </a>
      </div>
      <p className="get-in-touch">
        Get in Touch
      </p>
      <div className="contacts container">
        <div className="contact-min">
          <PhoneIcon className="icon" />
          <span className="icon-text">+1 (866) 217-3333</span>
        </div>
        <div className="contact-min">
          <FmdGoodIcon className="icon" />
          <span className="icon-text">
            2340 West Touhy Avenue, Suite B,<br /> Chicago, Illinois 60645, United States
          </span>
        </div>
        <div className="contact-min">
          <EmailIcon className="icon" />
          <span className="icon-text">support@amorservtech.com</span>
        </div>
      </div>
      <div className="container down">
        <p className="copyryt">©2024 Amorserv Tech. All rights reserved</p>
        <p className="copyryt-rest">Powered by <strong>Amorserv Solutions.</strong></p>
        <div className="terms-con">
            <a href="/">Privacy & Policy</a>
            <a href="/">Terms & Conditions</a>
        </div>
      </div>
      <p className="copyryt-res">Powered by <strong> Amorserv Solutions.</strong></p>

    </footer>
  );
};

export default Footer;
